import AxiosClient from "../../../services/axios.services";

class AreasServices {
  getAreas = params =>
    AxiosClient.get("/api/app/descriptor_perfil_area/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getArea = id =>
    AxiosClient.get(`/api/app/descriptor_perfil_area/${id}/`, {
      headers: { "Content-Type": "application/json" },
  });
  saveArea = req =>
    AxiosClient.post("/api/app/descriptor_perfil_area/", req, {
      headers: { "Content-Type": "application/json" },
    });
  editArea = (id, req) =>
    AxiosClient.put(`/api/app/descriptor_perfil_area/${id}/`, req, {
      headers: { "Content-Type": "application/json" },
    });
  deleteArea = id =>
    AxiosClient.delete(`/api/app/descriptor_perfil_area/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new AreasServices();